// extracted by mini-css-extract-plugin
export default {"ruleMain":"gameRules_ruleMain__OcXEg","subRule":"gameRules_subRule__Z6t22","labelGroup":"gameRules_labelGroup__O5xTw","icon":"gameRules_icon__9KuLp"};